import axios from "axios";
import { setupCache } from "axios-cache-interceptor";
import { API_URL, API_VERSION } from "@/config";

const API = (opts = {}, optsHeader = {}) => {
  /*
  |--------------------------------------------------
  | Custom axios api
  |--------------------------------------------------
  */
  const token = localStorage.getItem("jwt");
  const defaultOptions = {
    ...opts,
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      ...optsHeader,
    },
  };

  const baseURL = `${API_URL}/${API_VERSION}`;
  const axiosInstance = axios.create({
    baseURL,
    ...defaultOptions,
  });
  const axiosApi = setupCache(axiosInstance, {
    ttl: 15 * 60 * 1000,  // 15 minutes
  });
  axiosApi.interceptors.response.use(undefined, (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("jwt");
      if (window.location.pathname !== "/login") {
        window.location.href = `/login?redirect=${window.location.href}`;
      }
    }
    return Promise.reject(error);
  });

  return axiosApi;
};

export { API };
